/*
 * @@Author: MuYang
 */
import Api from './api'
import response from '../../utils/response'
// import {listTabSchema} from './mock'

// 获取全部tabs
export async function requestAllTab (
  {
    tenantType,
    objectApiName,
    layoutApiName,
    authCode
  },
  headerParams
) {
  const {type, url} = Api.getAllTab
  const computedUrl = `${url}/${tenantType}/${objectApiName}/${layoutApiName}/${authCode}`
  const {content, isOk} = await response(
    {
      method: type,
      url: computedUrl,
      params: {
        tenantType
      },
      headerParams,
      option: {
        loadingOptions: false
      }
    }
  )
  if (isOk) {
    return content
  }
}

// 获取模版
export async function requestTemplate (params) {
  const {type, url} = Api.queryTemplate
  const {content, isOk} = await response(
    {
      method: type,
      url,
      params,
      option: {
        loadingOptions: false
      }
    }
  )
  if (isOk) {
    return content
  }
}

// 上传导入模版
export async function requestImport ({objectApiName, operationApiName, resourceUrl}, headerParams) {
  const {type, url} = Api.import
  const uri = `${url}/${objectApiName}/${operationApiName}`
  const params = { resourceUrl }
  const {content, isOk} = await response(
    {
      method: type,
      url: uri,
      params,
      headerParams,
      option: {
        loadingOptions: false
      }
    }
  )
  if (isOk) {
    return content
  }
}

// 导出
export async function requestExport ({objectApiName, operationApiName, options}, headerParams) {
  const {type, url} = Api.export
  const uri = `${url}/${objectApiName}/${operationApiName}`
  const {isOk} = await response(
    {
      method: type,
      url: uri,
      params: options,
      headerParams,
      option: {
        loadingOptions: false
      }
    }
  )
  return isOk
}

// // 获取schema
// export async function requestTabSchema (
//   {
//     tenantType,
//     objectApiName,
//     tabLayoutApiName,
//     curAuthCode
//   }
// ) {
//   const {type, url} = Api.getTabLayout
//   const computedUrl = `${url}/${tenantType}/${objectApiName}/${tabLayoutApiName}/${curAuthCode}`
//   const {isOk, content} = await response(
//     {
//       method: type,
//       url: computedUrl,
//       headerParams: {tenantType},
//       option: {
//         loadingOptions: false
//       }
//     }
//   )
//   if (isOk) {
//     return content
//   }
// }
